import { IQuestionInfo } from '../../../../models'
import {
  PROJECT_TYPE,
  ProjectSections,
  ProjectType,
  ROLES,
  statesWithNoticeOfCommencement,
} from '@linqpal/models/src/dictionaries'
import address from './PropertyAddress/address'
import contractValue from './ProjectInformation/contractValue'
import primeContractorDetails from './ProjectInformation/primeContractorDetails'
import role from './ProjectInformation/role'
import timePeriod from './ProjectInformation/timePeriod'
import bondExists from './ProjectType/bondExists'
import descriptionOfPublicProject from './ProjectType/descriptionOfPublicProject'
import privateType from './ProjectType/privateType'
import projectBuiltFor from './ProjectType/projectBuiltFor'
import type from './ProjectType/type'
import details from './PropertyOwner/details'
import noticeOfCommencement from './PropertyAddress/noticeOfCommencement'
import ProjectStore from './Store'
import subcontractorShouldCarryBond from './ProjectType/subcontractorShouldCarryBond'
import uploadBond from './ProjectType/uploadBond'
import jobId from './PropertyAddress/jobId'
import uploadContract from './ProjectInformation/uploadContract'

export const sections: Record<ProjectSections, any> = {
  propertyAddress: {
    title: 'ProjectForm.address-title',
    subtitle: 'ProjectForm.address-subtitle',
    initialQuestions: [address, jobId],
    isNoticeRequired: (addressContent) => {
      if (
        statesWithNoticeOfCommencement.includes(
          addressContent.state.toLowerCase(),
        )
      )
        return [noticeOfCommencement]
      else return false
    },
    allQuestions: {
      address,
      jobId,
      noticeOfCommencement,
    },
  },
  projectInformation: {
    title: 'ProjectForm.project-info-title',
    initialQuestions: [contractValue, uploadContract, timePeriod, role],
    isPrimeContractorDetailsRequired: (
      val: string,
    ): IQuestionInfo[] | boolean => {
      if (![ROLES.PRIME_OR_GENERAL].includes(val))
        return [primeContractorDetails]
      else return false
    },
    allQuestions: {
      contractValue,
      uploadContract,
      timePeriod,
      role,
      primeContractorDetails,
    },
  },
  projectType: {
    title: 'ProjectForm.project-type-title',
    initialQuestions: [type],
    isPrivate: (val: ProjectType): IQuestionInfo[] | boolean => {
      if (val === PROJECT_TYPE.PRIVATE) return [privateType, projectBuiltFor]
      else return false
    },
    isPublic: (val: ProjectType): IQuestionInfo[] | boolean => {
      const newSetOfQuestions: IQuestionInfo[] = []
      if (val === PROJECT_TYPE.PUBLIC) {
        newSetOfQuestions.push(descriptionOfPublicProject, bondExists)
        if (ProjectStore.isSubcontractor)
          newSetOfQuestions.push(subcontractorShouldCarryBond)
        return newSetOfQuestions
      } else return false
    },
    isFederal: (val: ProjectType): IQuestionInfo[] | boolean => {
      if (val === PROJECT_TYPE.FEDERAL) {
        if (ProjectStore.isContractValueMoreThan()) return [uploadBond]
        else return [bondExists]
      } else return false
    },
    isBondExists: (val) => {
      if (val === 'yes') {
        return [uploadBond]
      } else {
        return false
      }
    },
    allQuestions: {
      type,
      privateType,
      projectBuiltFor,
      descriptionOfPublicProject,
      bondExists,
      subcontractorShouldCarryBond,
      uploadBond,
    },
  },
  propertyOwner: {
    title: 'ProjectForm.property-owner-title',
    initialQuestions: [details],
    allQuestions: {
      details,
    },
  },
}
